import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';
import { CreateEnvelopePayload } from '../types/CreateEnvelopePayload';

export const createEnvelope = (
  constructPost: ConstructPost,
  data: CreateEnvelopePayload,
): Promise<NonPaginatedResponse<Envelope> | undefined> =>
  constructPost<NonPaginatedResponse<Envelope>>(
    `${SIGNATURE_BASE_PATH}/envelope`,
    { data },
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
